export default function AffiliatePayouts() {
  return (
    <div>
      <h2>Affiliate Payouts</h2>
    </div>
  );
}